const data = {
  id: 1,
  title: 'Listen and mark the sentence intonation.(↘ ↗)',
  subTitle: 'Nghe và chọn ngữ điệu chính xác của câu.',
  audioUrl: 'https://cloud.softech.vn/storage/Data/Sentences/17704.mp3',
  question: "What's the matter with you?",
  answers: [
    { id: 1, answer: 'up', isCorrect: true },
    { id: 2, answer: 'down', isCorrect: false },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'special characters',
    },
  },
};

export default data;
